module.exports = __webpack_public_path__ + "static/media/Logo_webbill.b7bde5a6.png";